import { ChangeEvent, ReactNode } from 'react'

import { LoaderBlockVacancies } from '@/sections/repeatable/vacancy-overview/loader'
import VacanciesList from '@/components/vacancy-overview/vacancy-list'
import Pagination from '@/components/pagination'
import { VacancyDetailsCard } from '@/interfaces/vacancy'
import { VacanciesOverview } from '@/interfaces/schema'
import Section from '@/layouts/section'
import { GRID } from '@/lib/constants'
import useIsRay from '@/hooks/useIsRay'
import { useMediumScreen } from '@/hooks/useMediaQuery'
import FiltersCollection from '@/components/filters-collection'
import { MatchCriteriaFilters } from '@/interfaces/match-criteria'

type VacanciesSectionProps = Pick<VacanciesOverview, 'profileCta'> & {
  vacancies: VacancyDetailsCard[] | null
  totalPages: number
  currentPage: number
  matchCriteriaData: MatchCriteriaFilters[]
  handleCheckBoxChange: (e: ChangeEvent<HTMLInputElement>) => void
  handlePageChange: (page: number) => (e: React.MouseEvent) => void
  filters: string[]
  ctaCard: ReactNode
  loadingVacancies: boolean
}

const VacanciesSection = ({
  vacancies,
  loadingVacancies,
  filters,
  matchCriteriaData,
  ctaCard,
  currentPage,
  totalPages,
  handleCheckBoxChange,
  handlePageChange,
}: VacanciesSectionProps) => {
  const isRay = useIsRay()
  const isMedScreen = useMediumScreen()
  const marginTop =
    isMedScreen && isRay ? 'mt-96' : isMedScreen && !isRay ? 'mt-80' : 'mt-0'

  return (
    <Section className={`${GRID} ${marginTop} mx-auto`}>
      <FiltersCollection
        filters={filters}
        filtersCollectionData={matchCriteriaData}
        handleCheckBoxChange={handleCheckBoxChange}
        className="col-start-1 col-end-3 lg:col-end-5 w-full"
      />
      {vacancies && !loadingVacancies ? (
        <VacanciesList
          className="col-start-1 col-end-3 md:col-start-3 md:col-end-7 lg:col-start-5 lg:col-end-13 w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-8 gap-lg self-start"
          vacancies={vacancies}
          ctaCard={ctaCard}
        />
      ) : (
        <LoaderBlockVacancies />
      )}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
      />
    </Section>
  )
}

export default VacanciesSection
